import { type Modification, type ModificationsMap } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getModificationsMap(modifications: Modification[]): ModificationsMap {
  return new Map(modifications.map((modification) => [modification.id, modification]));
}
